export default "__VITE_ASSET__6iv3NDZj__"